module.exports = __webpack_public_path__ + "3ba6fb27a0ea92c2f1513add6dbddf37.woff2";